<!--
  ~ Copyright (c) by INFODATA-GROUP. All rights reserved.
  ~ No part of this publication may be reproduced, distributed,
  ~ or transmitted in any form or by any means, including photocopying, recording,
  ~ or other electronic or mechanical methods, without the prior written permission of the publisher,
  ~ except in the case of brief quotations embodied in critical
  ~ reviews and certain other noncommercial uses permitted by copyright law.
  ~  author : vhe
  ~  date : 02/03/2021 07:39
  -->

<!-- Calendar horizontal -->
@if (options().orientation === 'horizontal') {
  <div #container class="calendar-container">
    @if (taskManager().mode === 'separate') {
      <div
        class="calendar horizontal"
        (click)="menuIsOpened = false"
        (mouseup)="onMouseUp($event)"
      >
        @switch (options().view) {
          @case (calendarViews.day) {
            @if (options().day.hoursSection) {
              <infl-calendar-view-day-by-hour-horizontal
                #viewH
                #viewDayH
                #currentView
                [resources]="groups"
                [day]="date() ? date() : options().date"
                [tasks]="tasks"
                [showResources]="true"
                [resourceTitle]="options().resources.title"
                [canDrag]="options().canDrag"
                [enable]="options().enable"
                [canResize]="options().canResize"
                [canSelect]="options().canSelect"
                [cellWidth]="options().week.horizontalWidthCell"
                [start]="options().day.start"
                [end]="options().day.end"
                [displayTime]="true"
                [dragByOutside]="taskManager().draggingTask"
                [hourDivCount]="options().day.hoursSection"
                [sectionHeight]="options().day.hSectionHeight"
                [taskHeight]="options().day.taskHeight"
                [teleworks]="teleworks()"
                (taskClick)="clickTask.emit($event)"
                (taskDblClick)="dblClickTask.emit($event)"
                (taskCreation)="onHorizontalTaskCreation($event)"
                (taskContextMenu)="onTaskRightClick({ task: $event })"
                (taskUpdate)="taskUpdate.emit($event)"
                (taskHover)="taskHover.emit($event)"
                (hourSelection)="onSelectPeriodDay(viewH, $event)"
                (hourPreselection)="preselectPeriod.emit($event)"
                (clickOnSelection)="clickOnSelection.emit($event)"
                (dblClickOnSelection)="dblClickOnSelection.emit($event)"
              >
              </infl-calendar-view-day-by-hour-horizontal>
            } @else {
              <infl-calendar-view-day-horizontal
                #viewH
                #currentView
                [resources]="groups"
                [day]="date() ? date() : options().date"
                [tasks]="tasks"
                [showResources]="true"
                [resourceTitle]="options().resources.title"
                [canDrag]="options().canDrag"
                [enable]="options().enable"
                [canResize]="options().canResize"
                [canSelect]="options().canSelect"
                [cellWidth]="'auto'"
                [startMorning]="options().day.start"
                [endMorning]="options().day.endMorning"
                [startAfternoon]="options().day.startAfternoon"
                [endAfternoon]="options().day.end"
                [displayTime]="true"
                [dragByOutside]="taskManager().draggingTask"
                [numberSection]="options().day.daySections"
                [sectionHeight]="options().day.hSectionHeight"
                [taskHeight]="options().day.taskHeight"
                [teleworks]="teleworks()"
                (taskClick)="clickTask.emit($event)"
                (taskDblClick)="dblClickTask.emit($event)"
                (taskCreation)="onHorizontalTaskCreation($event)"
                (taskUpdate)="taskUpdate.emit($event)"
                (taskHover)="taskHover.emit($event)"
                (hourSelection)="onSelectPeriodDay(viewH, $event)"
                (hourPreselection)="preselectPeriod.emit($event)"
                (clickOnSelection)="clickOnSelection.emit($event)"
                (dblClickOnSelection)="dblClickOnSelection.emit($event)"
              >
              </infl-calendar-view-day-horizontal>
            }
          }
          @case (CalendarViews.week) {
            <infl-calendar-view-week-horizontal
              #viewH
              #currentView
              [resources]="groups"
              [resourceTitle]="options().resources.title"
              [day]="date() ? date() : options().date"
              [start]="options().day.start"
              [endMorning]="options().day.endMorning"
              [days]="options().week.dayOfWeek"
              [tasks]="tasks"
              [startAfternoon]="options().day.startAfternoon"
              [end]="options().day.end"
              [numberSection]="options().day.daySections"
              [cellWidth]="options().week.horizontalWidthCell"
              [canDrag]="options().canDrag"
              [canSelect]="options().canSelect"
              [enable]="options().enable"
              [canResize]="options().canResize"
              [dragByOutside]="taskManager().draggingTask"
              [draggingTask]="draggingTask"
              [hourDivCount]="options().day.hoursSection"
              [sectionHeight]="options().day.hSectionHeight"
              [taskHeight]="options().day.taskHeight"
              [showResources]="true"
              [teleworks]="teleworks()"
              (taskUpdate)="onHorizontalTaskUpdate($event)"
              (taskCreation)="onHorizontalTaskCreation($event)"
              (taskHover)="taskHover.emit($event)"
              (taskClick)="clickTask.emit($event)"
              (taskDblClick)="dblClickTask.emit($event)"
              (taskContextMenu)="onTaskRightClick({ task: $event })"
              (periodSelection)="onSelectPeriod(viewH, $event)"
              (hourPreselection)="preselectPeriod.emit($event)"
              (clickOnSelection)="clickOnSelection.emit($event)"
              (dblClickOnSelection)="dblClickOnSelection.emit($event)"
              (startDraggingTask)="draggingTask = $event"
            >
            </infl-calendar-view-week-horizontal>
          }
          @case (CalendarViews.fortnight) {
            <infl-calendar-view-fortnight-horizontal
              #currentView
              [resources]="groups"
              [resourceTitle]="options().resources.title"
              [dayWeek1]="date() ? date() : options().date"
              [start]="options().day.start"
              [endMorning]="options().day.endMorning"
              [days]="options().week.dayOfWeek"
              [tasks]="tasks"
              [startAfternoon]="options().day.startAfternoon"
              [numberSection]="options().day.daySections"
              [end]="options().day.end"
              [cellWidth]="options().week.horizontalWidthCell"
              [canDrag]="options().canDrag"
              [canSelect]="options().canSelect"
              [enable]="options().enable"
              [canResize]="options().canResize"
              [dragByOutside]="taskManager().draggingTask"
              [hourDivCount]="options().day.hoursSection"
              [sectionHeight]="options().day.hSectionHeight"
              [taskHeight]="options().day.taskHeight"
              [teleworks]="teleworks()"
              (taskUpdate)="taskUpdate.emit($event)"
              (taskCreation)="onHorizontalTaskCreation($event)"
              (taskHover)="taskHover.emit($event)"
              (taskClick)="clickTask.emit($event)"
              (taskDblClick)="dblClickTask.emit($event)"
              (taskContextMenu)="onTaskRightClick({ task: $event })"
              (periodSelection)="
                onSelectPeriod($event.component, $event.selection)
              "
              (hourPreselection)="preselectPeriod.emit($event)"
              (clickOnSelection)="clickOnSelection.emit($event)"
              (dblClickOnSelection)="dblClickOnSelection.emit($event)"
            >
            </infl-calendar-view-fortnight-horizontal>
          }
          @case (calendarViews.month) {
            <infl-calendar-view-month-horizontal
              #viewH
              #currentView
              [resources]="groups"
              [resourceTitle]="options().resources.title"
              [sections]="options().day.hoursSection"
              [dragByOutside]="taskManager().draggingTask"
              [date]="date() ? date() : options().date"
              [enable]="options().enable"
              [tasks]="tasks"
              [canDrag]="options().canDrag"
              [canResize]="options().canResize"
              [canSelect]="options().canSelect"
              [dayTimeStart]="options().day.start"
              [dayTimeEnd]="options().day.end"
              [teleworks]="teleworks()"
              (cellClick)="onCellClick($event)"
              (cellsSelection)="onSelect(viewH, $event)"
              (taskHover)="taskHover.emit($event)"
              (cellPreselection)="preselectPeriod.emit($event)"
              (clickOnSelection)="clickOnSelection.emit($event)"
              (dblClickOnSelection)="dblClickOnSelection.emit($event)"
              (taskUpdate)="taskUpdate.emit($event)"
              (taskCreation)="onHorizontalTaskCreation($event)"
              (taskClick)="clickTask.emit($event)"
              (taskDblClick)="onTaskClick($event, true)"
              (taskContextMenu)="onTaskRightClick($event)"
            >
            </infl-calendar-view-month-horizontal>
          }
        }
      </div>
    }
  </div>
}

<!-- Calendar vertical -->
@if (options().orientation === 'vertical') {
  @if (options().view === calendarViews.resourcesDetailed) {
    <div #container>
      <infl-agenda-detailed-view [date]="options().date" [hourStart]="options().day.start"
                                 [viewId]="viewId()"
                                 [fullRender]="fullRender()"
                                 [hourEndMorning]="options().day.endMorning"
                                 [hourStartAfternoon]="options().day.startAfternoon"
                                 [hourEnd]="options().day.end"
                                 [daySection]="options().day.daySections"
                                 [hoursSection]="options().day.hoursSection"
                                 [canDrag]="options().canDrag"
                                 [canResize]="options().canResize"
                                 [canSelect]="options().canSelect"
                                 [tasks]="taskManager().data"
                                 [resources]="taskManager().groups"
                                 [outsideDraggingTask]="taskManager().draggingTask"
                                 [sectionHeight]="options().day.hSectionHeight"
                                 [teleworks]="teleworks()"
                                 [paginationStep]="options().paginationStep"
                                 [currentPage]="taskManager().currentPage"
                                 (periodHovered)="preselectPeriod.emit($event)"
                                 (periodSelected)="selectPeriod.emit($event)"
                                 (taskHover)="taskHover.emit($event)"
                                 (taskClick)="clickTask.emit($event)"
                                 (taskUpdate)="taskUpdate.emit($event)"
                                 (taskCreation)="taskCreation.emit($event)"
      ></infl-agenda-detailed-view>
    </div>
  } @else {
    <div #container class="calendar-container">
      @if (options().view === calendarViews.day ||
      options().view === calendarViews.week ||
      options().view === calendarViews.fortnight) {
        <div class="hours">
          <infl-calendar-hours
            [withGroup]="taskManager().mode === 'separate'"
            [start]="options().day.start"
            [end]="options().day.end"
            [canDrag]="options().canDrag"
            [canResize]="options().canResize"
            [hourDivCount]="options().day.hoursSection"
          >
          </infl-calendar-hours>
        </div>
      }
      @if (options().view === calendarViews.resources) {
        <div class="days">
          <infl-calendar-days
            [date]="options().date"
            [grayedCells]="options().month.grayedCells"
            (loadSections)="resourceSections = $event"
          >
          </infl-calendar-days>
        </div>
      }
      @if (taskManager().mode === 'together') {
        <div class="calendar" (click)="menuIsOpened = false">
          @switch (options().view) {
            @case (calendarViews.month) {
              <infl-calendar-view-month
                #currentView
                [date]="date() ? date() : options().date"
                [grayedCells]="options().month.grayedCells"
                [tasks]="tasks"
                [rowHeight]="options().month.rowHeight"
                [canNavigate]="options().canNavigate"
                [displayTotalTasksDuration]="options().viewVerticalTotalTasksDuration"
                [canDrag]="options().canDrag"
                [canResize]="options().canResize"
                [canSelect]="options().canSelect"
                [enable]="options().enable"
                [dragByOutside]="taskManager().draggingTask"
                [dayTimeStart]="options().day.start"
                [dayTimeEnd]="options().day.end"
                [teleworks]="teleworks()"
                (cellClick)="onCellClick($event)"
                (taskUpdate)="taskUpdate.emit($event)"
                (taskHover)="taskHover.emit($event)"
                (cellsSelection)="onSelect(currentView, $event)"
                (taskClick)="onTaskClick($event)"
                (taskDblClick)="onTaskClick($event, true)"
                (dateChange)="dateChange.emit($event)"
              >
              </infl-calendar-view-month>
            }
            @case (weekOrFortnight()) {
              <infl-calendar-view-week
                #currentView
                [tasks]="tasks"
                [date]="date() ? date() : options().date"
                [days]="options().week.dayOfWeek"
                [fortnight]="options().view === CalendarViews.fortnight"
                [options]="options()"
                [canDrag]="options().canDrag"
                [canResize]="options().canResize"
                [canSelect]="options().canSelect"
                [teleworks]="teleworks()"
                [viewTotalTasksDuration]="options().viewVerticalTotalTasksDuration"
                (periodSelection)="selectPeriod.emit($event)"
                (periodPreselection)="preselectPeriod.emit($event)"
                (taskHover)="taskHover.emit($event)"
                (clickOnSelection)="clickOnSelection.emit($event)"
                (dblClickOnSelection)="dblClickOnSelection.emit($event)"
                (dragTask)="draggingTask = $event"
                (taskContextMenu)="onTaskRightClick($event)"
                (taskUpdate)="taskUpdate.emit($event)"
              >
              </infl-calendar-view-week>
            }
            @case (calendarViews.day) {
              <infl-calendar-view-day
                #currentView
                [tasks]="tasks"
                [day]="date() ? date() : options().date"
                [start]="options().day.start"
                [end]="options().day.end"
                [hourDivCount]="options().day.hoursSection"
                [sectionHeight]="options().day.sectionHeight"
                [canDrag]="options().canDrag"
                [canResize]="options().canResize"
                [canSelect]="options().canSelect"
                [teleworks]="teleworks()"
                [viewTotalTasksDuration]="options().viewVerticalTotalTasksDuration"
                (clickOnSelection)="clickOnSelection.emit($event)"
                (taskHover)="taskHover.emit($event)"
                (hourPreselection)="print($event)"
                (dblClickOnSelection)="dblClickOnSelection.emit($event)"
                (taskUpdate)="taskUpdate.emit($event)"
                (taskDblClick)="dblClickTask.emit($event)"
                (taskClick)="clickTask.emit($event)"
              >
              </infl-calendar-view-day>
            }
          }
        </div>
      }
      @if (taskManager().mode === 'separate') {
        <div
          class="calendar-grouped"
          (mouseup)="onMouseUp($event)"
          (click)="menuIsOpened = false"
        >
          @for (header of groups
            | resourcePagination
            : taskManager().currentPage
              : options().paginationStep;
            track header.id;
            let i = $index) {
            <div
              class="header-group"
              [ngStyle]="{ 'flex-grow': header.tasksGroups.length + '' }"
            >
              <div class="title">
                <div class="text">
                  {{ header.label }}
                  @if (options().viewVerticalTotalTasksDuration && options().view !== calendarViews.resources) {
                    <span class="total"> ({{ header.totalTasksDuration | duration }})</span>
                  }
                </div>
              </div>
              <div class="groups">
                @for (group of header.tasksGroups;
                  track group.id;
                  let j = $index) {
                  <div
                    class="group"
                    [class.r-view]="options().view === calendarViews.resources"
                  >
                    <div class="title">
                      <div class="text">
                        {{ group.label }}
                        @if (options().viewVerticalTotalTasksDuration && options().view !== calendarViews.resources) {
                          <span class="total"> ({{ group.totalTasksDuration | duration }})</span>
                        }
                      </div>
                    </div>
                    <div class="partial-calendar" #view>
                      @switch (options().view) {
                        @case (calendarViews.month) {
                          <infl-calendar-view-month
                            #currentViews
                            #currentView
                            [date]="date() ? date() : options().date"
                            [grayedCells]="options().month.grayedCells"
                            [tasks]="group.tasks"
                            [resource]="group.id"
                            [partial]="true"
                            [displayTotalTasksDuration]="options().viewVerticalTotalTasksDuration"
                            [dragByOutside]="taskManager().draggingTask"
                            [canDrag]="options().canDrag"
                            [rowHeight]="options().month.rowHeight"
                            [canNavigate]="options().canNavigate"
                            [canSelect]="options().canSelect"
                            [enable]="options().enable"
                            [dayTimeStart]="options().day.start"
                            [dayTimeEnd]="options().day.end"
                            [teleworks]="teleworks()"
                            (cellClick)="onCellClick($event)"
                            (clickOnSelection)="
                            onSelectionClick($event, group, false)
                          "
                            (dblClickOnSelection)="
                            onSelectionClick($event, group, true)
                          "
                            (cellsSelection)="
                            onSelect(currentViews, $event, group)
                          "
                            (cellPreselection)="
                            onPreselectPeriod(currentViews, $event, group)
                          "
                            (taskContextMenu)="onTaskRightClick($event)"
                            (taskClick)="onTaskClick($event)"
                            (taskDblClick)="onTaskClick($event, true)"
                            (dragTask)="draggingTask = $event"
                            (taskHover)="taskHover.emit($event)"
                            (taskCreation)="onTaskCreation($event, header, group)"
                            (taskUpdate)="taskUpdate.emit($event)"
                            (dropOutside)="
                            onMonthDropOutside($event, header, group)
                          "
                            (dateChange)="dateChange.emit($event)"
                          >
                          </infl-calendar-view-month>
                        }
                        @case (weekOrFortnight()) {
                          <infl-calendar-view-week
                            #currentViews
                            #currentView
                            [tasks]="group.tasks"
                            [options]="options()"
                            [days]="options().week.dayOfWeek"
                            [fortnight]="options().view === CalendarViews.fortnight"
                            [reduce]="true"
                            [date]="date() ? date() : options().date"
                            [dragByOutside]="taskManager().draggingTask"
                            [canDrag]="options().canDrag"
                            [canResize]="options().canResize"
                            [canSelect]="options().canSelect"
                            [teleworks]="teleworks()"
                            [resource]="group.id"
                            [viewTotalTasksDuration]="options().viewVerticalTotalTasksDuration"
                            (dragTask)="draggingTask = $event"
                            (taskClick)="clickTask.emit($event)"
                            (taskDblClick)="dblClickTask.emit($event)"
                            (taskContextMenu)="onTaskRightClick($event)"
                            (taskCreation)="onTaskCreation($event, header, group)"
                            (dropOutside)="
                            onWeekDropOutside($event, header, group)
                          "
                            (periodSelection)="
                            onSelectPeriod(currentViews, $event, group)
                          "
                            (periodPreselection)="
                            onPreselectPeriod(currentViews, $event, group)
                          "
                            (taskHover)="taskHover.emit($event)"
                            (clickOnSelection)="
                            onSelectionClick($event, group, false)
                          "
                            (dblClickOnSelection)="
                            onSelectionClick($event, group, true)
                          "
                            (taskUpdate)="taskUpdate.emit($event)"
                          >
                          </infl-calendar-view-week>
                        }
                        @case (calendarViews.day) {
                          <infl-calendar-view-day
                            #currentViews
                            #currentView
                            [tasks]="group.tasks"
                            [day]="date() ? date() : options().date"
                            [start]="options().day.start"
                            [end]="options().day.end"
                            [hourDivCount]="options().day.hoursSection"
                            [sectionHeight]="options().day.sectionHeight"
                            [dragByOutside]="taskManager().draggingTask"
                            [canDrag]="options().canDrag"
                            [canResize]="options().canResize"
                            [canSelect]="options().canSelect"
                            [teleworks]="teleworks()"
                            [resource]="group.id"
                            [viewTotalTasksDuration]="options().viewVerticalTotalTasksDuration"
                            (dragTask)="draggingTask = $event"
                            (taskClick)="clickTask.emit($event)"
                            (taskDblClick)="dblClickTask.emit($event)"
                            (taskUpdate)="taskUpdate.emit($event)"
                            (taskCreation)="onTaskCreation($event, header, group)"
                            (taskContextMenu)="onTaskRightClick($event)"
                            (taskHover)="taskHover.emit($event)"
                            (hourSelection)="
                            onSelectPeriodDay(currentViews, $event, group)
                          "
                            (hourPreselection)="
                            onPreselectPeriod(currentViews, $event, group)
                          "
                            (clickOnSelection)="
                            onSelectionClick($event, group, false)
                          "
                            (dblClickOnSelection)="
                            onSelectionClick($event, group, true)
                          "
                            (dropOutside)="
                            onDayDropOutside($event, header, group)
                          "
                          >
                          </infl-calendar-view-day>
                        }
                        @case (calendarViews.resources) {
                          <infl-calendar-view-resource
                            #currentViews
                            [sections]="resourceSections"
                            [tasks]="group.tasks"
                            [dragByOutside]="taskManager().draggingTask"
                            [teleworks]="teleworks()"
                            [resource]="group.id"
                            [canDrag]="options().canDrag"
                            [canSelect]="options().canSelect"
                            [enable]="options().enable"
                            [dayTimeStart]="options().day.start"
                            [dayTimeEnd]="options().day.end"
                            (clickOnSelection)="
                            onSelectionClick($event, group, false)
                          "
                            (dblClickOnSelection)="
                            onSelectionClick($event, group, true)
                          "
                            (sectionSelection)="
                            onSelect(currentViews, $event, group)
                          "
                            (sectionPreselection)="
                            onPreselectPeriod(currentViews, $event, group)
                          "
                            (taskClick)="onTaskClick($event)"
                            (taskHover)="taskHover.emit($event)"
                            (taskDblClick)="onTaskClick($event, true)"
                            (dragTask)="draggingTask = $event"
                            (taskCreation)="onTaskCreation($event, header, group)"
                            (taskUpdate)="taskUpdate.emit($event)"
                            (dropOutside)="
                            onViewResourceDropOutside($event, header, group)
                          "
                          >
                          </infl-calendar-view-resource>
                        }
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  }
}

@if (menuIsOpened) {
  <div
    class="context-menu"
    [ngStyle]="menuPosition"
    (contextmenu)="prevent($event)"
  >
    <div class="dropdown-content" [tabIndex]="1">
      @if (displayedActions && displayedActions.length > 0) {
        <div>
          @for (action of displayedActions; track action.name) {
            @if (action.enable) {
              <div
                class="dropdown-item"
                (click)="onActionClick(action, $event)"
              >
                <i class="icon fal icon fa-{{ action.icon }}"></i>
                <div>{{ action.text | translate }}</div>
              </div>
            }
          }
        </div>
      }
    </div>
  </div>
}
